/**
 * Import all configuration from ./config directory
 *
 * @see https://webpack.js.org/guides/dependency-management/#context-module-api
 */
const importAll = r => r.keys().forEach(r);
importAll(require.context('./config', true, /\.js$/i));
